import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'

type FulfillmentMode = 'pickup' | 'delivery'

interface FulfillmentModeState {
  mode: FulfillmentMode
}

const getInitialFulfillmentMode = (): FulfillmentMode => {
  const stored = localStorage.getItem('fulfillmentMode')
  if (stored === 'pickup' || stored === 'delivery') {
    return stored
  }
  return 'pickup'
}

const initialState: FulfillmentModeState = {
  mode: getInitialFulfillmentMode(),
}

const fulfillmentModeSlice = createSlice({
  name: 'fulfillmentMode',
  initialState,
  reducers: {
    setFulfillmentMode: (state, action: PayloadAction<FulfillmentMode>) => {
      state.mode = action.payload
      localStorage.setItem('fulfillmentMode', action.payload)
      
      if (navigator.vibrate) {
        navigator.vibrate(10)
      }
    },
    toggleFulfillmentMode: (state) => {
      state.mode = state.mode === 'pickup' ? 'delivery' : 'pickup'
      localStorage.setItem('fulfillmentMode', state.mode)
      
      if (navigator.vibrate) {
        navigator.vibrate(10)
      }
    },
  },
})

export const { setFulfillmentMode, toggleFulfillmentMode } = fulfillmentModeSlice.actions

export const selectFulfillmentMode = (state: RootState) => state.fulfillmentMode.mode

export default fulfillmentModeSlice.reducer
